import { useEffect, useRef } from "react";

export default function HeroSection() {
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(30px)";
    const timer = setTimeout(() => {
      el.style.transition = "opacity 0.9s ease, transform 0.9s ease";
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  const handleScroll = (href: string) => {
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden pt-24">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/57109f4d45d7b59bfc7cbc97b9371696.jpg"
          alt="CashLearn hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1e3a5f]/85 via-[#1d4ed8]/55 to-[#1e3a5f]/85" />
      </div>

      <div ref={textRef} className="relative z-10 w-full text-center px-6 md:px-12 max-w-5xl mx-auto">
        <h1 className="font-['DM_Serif_Display'] text-4xl md:text-6xl lg:text-7xl text-white leading-tight mb-6">
          <span className="text-white font-normal uppercase tracking-tight">Cash&nbsp;&nbsp;Learn</span>
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed font-['Inter']">
          A national initiative developing vertically aligned financial and economic systems education frameworks spanning from middle school to high school.
        </p>


        <div className="mt-14 mx-auto max-w-2xl bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-8 py-6 text-white text-left">
          <h3 className="font-['Playfair_Display'] text-lg font-semibold mb-2 text-[#93c5fd]">The Economic Preparedness Gap</h3>
          <p className="text-white/75 text-sm leading-relaxed font-['Inter']">
            Students graduate without understanding credit systems, taxation structures, workforce compensation models, inflation, or capital allocation principles. Financial literacy mandates remain inconsistent across states, creating measurable economic preparedness gaps.
          </p>
        </div>


      </div>

    </section>
  );
}
